import { StateNode } from '@ansys-internal/awf-angular/store';
import { AWCTreeItem } from '@ansys-internal/awc-angular/trees';

export class ConfigurationItemState implements StateNode<AWCTreeItem[]> {
  key: string = 'configurations';
  mutable: boolean = true;
  observeInitial: boolean = true;
  defaultValue: () => AWCTreeItem[] = () => [];
}
